// store/modules/setter.js
import api from '@/service/api'
import Swal from 'sweetalert2'

export default {
    namespaced: true,
    state: () => ({
        types: [],
        events: [],
        setters: []
    }),
    mutations: {
        setTypes(state, payload) {
            state.types = payload
        },
        setEvents(state, payload) {
            state.events = payload
        },
        setSetters(state, payload) {
            state.setters = payload
        }
    },
    actions: {
        async fetchTypes({ commit }) {
            try {
                const { data } = await api.type('get')
                commit('setTypes', data.data || [])
            } catch (err) {
                console.error('[Setter Store] fetchTypes failed:', err)
            }
        },
        async fetchEvents({ commit }) {
            try {
                const { data } = await api.event('get')
                commit('setEvents', data.data || [])
            } catch (err) {
                console.error('[Setter Store] fetchEvents failed:', err)
            }
        },
        async fetchSetters({ commit }) {
            try {
                const { data } = await api.setter('get')
                commit('setSetters', data.data || [])
            } catch (err) {
                console.error('[Setter Store] fetchSetters failed:', err)
            }
        },
        async createSetter({ dispatch }, payload) {
            try {
                const res = await api.setter('post', payload)
                Swal.fire('Success', 'Time set successfully.', 'success')
                dispatch('fetchSetters') // รีเฟรชข้อมูลหลังบันทึก
                return res.data
            } catch (err) {
                const msg = err.response?.data?.error || 'Failed to set time.'
                Swal.fire('Error', msg, 'error')
                throw err
            }
        }
    },
    getters: {
        getTypeByName: state => name =>
            state.types.find(t => t.type_name === name),
        getEventByName: state => name =>
            state.events.find(e => e.event_name === name)
    }
}
